import { EnquiryTenantSettingsDto } from '@careapp-group/ng-sdk';
import { caCreateEntitySelectors } from '../../../store/entity-state/entity-selectors';
import { EnquiriesTenantSettingsState } from './enquiries-tenant-settings.reducer';
import { createSelector } from '@ngrx/store';
import { Tenants } from '../../../store';
import { TenantSelectors } from '../../../store/tenants/tenants.selectors';

export const EnquiriesTenantSettingsSelectors = caCreateEntitySelectors<
  EnquiryTenantSettingsDto,
  EnquiriesTenantSettingsState
>('enquiriesTenantSettings');

export const getEnquiriesTenantSettingsForSelectedTenant = createSelector(
  TenantSelectors.getSelectedId,
  EnquiriesTenantSettingsSelectors.getEntities,
  (tenantId, settings) => settings[tenantId],
);
